const defaultMessage = 'This field is required.'

export const RequiredValidator =
    (message = defaultMessage) =>
    (value: string) => {
        return value && value.length > 0 ? undefined : message
    }
